import { MaxUint256 } from '@ethersproject/constants'
import { Interface } from '@ethersproject/abi'
import { BigNumber } from '@ethersproject/bignumber'
import { DELAY_ADDRESS, ERC20_ABI, Ether, GanacheEther, KovanEther } from '../constants'
import { Currency, CurrencyValue, Token } from '../model'
import { useChainCall } from './useChainCalls'
import { useEthers } from './useEthers'
import { getStakingAddress, StakingOption } from '../pages/token/staking/utils'

const encoder = new Interface(ERC20_ABI)

export function useApprovalForDelay(currency?: Currency) {
  const { chainId } = useEthers()
  return useApproval(currency, chainId && DELAY_ADDRESS[chainId])
}

export function useApprovalForStaking(stakingOption: StakingOption, currency?: Currency) {
  const { chainId } = useEthers()
  return useApproval(currency, chainId && getStakingAddress(stakingOption, chainId))
}

function useApproval(currency?: Currency, contractAddress?: string) {
  const { chainId, account } = useEthers()
  const data = useChainCall(
    currency instanceof Token &&
      currency.chainId === chainId &&
      !!contractAddress &&
      !!account && {
        address: currency.address,
        data: encoder.encodeFunctionData('allowance', [account, contractAddress]),
      }
  )

  if (currency === Ether || currency === KovanEther || currency === GanacheEther) {
    return new CurrencyValue(currency, MaxUint256)
  } else if (currency && data) {
    return new CurrencyValue(currency, BigNumber.from(data))
  }
}
